import { useQuery, gql } from "@apollo/client"
import { offsetLimitPagination } from "@apollo/client/utilities"
import { ASSET_TYPE_FIELDS } from "./fragments/assetTypeFieldsFragment"

const ASSET_TYPES_QUERY = gql`
  query AssetTypes($offset: Int, $limit: Int) {
    assetTypes {
      list(limit: $limit, offset: $offset) {
        ...AssetTypeFields
      }
    }
  }
  ${ASSET_TYPE_FIELDS}
`

const useQueryAssetTypes = (options) => useQuery(ASSET_TYPES_QUERY, options)

const assetTypesTypePolicies = {
  scoped: {
    AssetTypesQuery: {
      merge(prev, next) {
        return {
          ...(prev || {}),
          ...next
        }
      },
      fields: {
        list: offsetLimitPagination(["filter"])
      }
    }
  }
}

export { useQueryAssetTypes, assetTypesTypePolicies }
